export default {
  loading: false,
  loadingExporting: false,
  transactionsBatch: [],
  transactionsBatchTotal: 0,
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-order/features/transactions-batch/store/states.js